<reset-password-page>
  <div if="{locale}" class="container">
    <div class="reset-card">
      <div if={state.loading} class="loading-state">
        <div class="spinner"></div>
        <h2>{locale?.t('resetpassword_validating')}</h2>
        <p>{locale?.t('resetpassword_validating_message')}</p>
      </div>

      <div if={state.tokenValid && !state.success} class="password-form-state">
        <h2>{locale?.t('resetpassword_title')}</h2>
        <p class="form-description">{locale?.t('resetpassword_subtitle')}</p>
        
        <form onsubmit={handlePasswordSubmit} autocomplete="on">
          <input
            type="email"
            name="username"
            autocomplete="username"
            value={state.userEmail}
            style="display: none;"
            tabindex="-1"
            aria-hidden="true"
          />
          <div class="password-field-container">
            <div class="form-group password-input-column">
              <label for="new-password">{locale?.t('resetpassword_newpassword')}</label>
              <div class="password-input-wrapper">
                <input
                  type={state.showPassword ? 'text' : 'password'}
                  id="new-password"
                  name="new-password"
                  autocomplete="new-password"
                  value={state.password}
                  oninput={handlePasswordInput}
                  required
                  minlength="12"
                  placeholder="{locale?.t('resetpassword_newpassword_placeholder')}"
                />
                <button
                  type="button"
                  class="password-toggle"
                  onclick={togglePasswordVisibility}
                  aria-label={state.showPassword ? locale?.t('resetpassword_hidepassword') : locale?.t('resetpassword_showpassword')}
                >
                  <i class="{state.showPassword ? 'icon-eye-blocked' : 'icon-eye'}"></i>
                </button>
              </div>
            </div>
            
            <div class="password-requirements">
              <div class="requirements-title">{locale?.t('resetpassword_requirements')}</div>
              <ul class="requirements-list">
                <li class="{state.password.length >= 12 ? 'requirement-met' : 'requirement-pending'}">
                  {locale?.t('resetpassword_requirement_length')} <span class="char-count">({state.password.length}/12)</span>
                </li>
                <li class="{/[A-Z]/.test(state.password) ? 'requirement-met' : 'requirement-pending'}">
                  {locale?.t('resetpassword_requirement_uppercase')}
                </li>
                <li class="{/[a-z]/.test(state.password) ? 'requirement-met' : 'requirement-pending'}">
                  {locale?.t('resetpassword_requirement_lowercase')}
                </li>
                <li class="{/[0-9]/.test(state.password) ? 'requirement-met' : 'requirement-pending'}">
                  {locale?.t('resetpassword_requirement_number')}
                </li>
                <li class="{/[@$!%*?&#^()_+\-=\[\]{}|;:,.<>~`]/.test(state.password) ? 'requirement-met' : 'requirement-pending'}">
                  {locale?.t('resetpassword_requirement_special')}
                </li>
              </ul>
            </div>
          </div>

          <div class="form-group">
            <label for="confirm-password">{locale?.t('resetpassword_confirmpassword')}</label>
            <div class="password-input-wrapper">
              <input
                type={state.showConfirmPassword ? 'text' : 'password'}
                id="confirm-password"
                name="confirm-password"
                autocomplete="new-password"
                value={state.confirmPassword}
                oninput={handleConfirmPasswordInput}
                required
                minlength="8"
                placeholder="{locale?.t('resetpassword_confirmpassword_placeholder')}"
              />
              <button
                type="button"
                class="password-toggle"
                onclick={toggleConfirmPasswordVisibility}
                aria-label={state.showConfirmPassword ? locale?.t('resetpassword_hidepassword') : locale?.t('resetpassword_showpassword')}
              >
                <i class="{state.showConfirmPassword ? 'icon-eye-blocked' : 'icon-eye'}"></i>
              </button>
            </div>
          </div>

          <div if={state.passwordError} class="error-alert">{state.passwordError}</div>

          <button
            type="submit"
            class="btn btn-primary btn-block"
            disabled={state.resetting}
          >
            {state.resetting ? locale?.t('resetpassword_resetting') : locale?.t('resetpassword_resetbutton')}
          </button>
        </form>
      </div>

      <div if={state.success} class="success-state">
        <div class="success-icon">✓</div>
        <h2>{locale?.t('resetpassword_success_title')}</h2>
        <p>{state.message}</p>
        <p class="next-step">{locale?.t('resetpassword_success_nextstep')}</p>
        <a href="#/login" class="btn btn-primary">
          {locale?.t('resetpassword_success_gotologin')}
        </a>
      </div>

      <div if={state.error} class="error-state">
        <div class="error-icon">✗</div>
        <h2>{locale?.t('resetpassword_failed_title')}</h2>
        <p class="error-message">{state.message}</p>
        <div class="error-actions">
          <a href="#/login" class="btn btn-primary">{locale?.t('resetpassword_failed_returntologin')}</a>
        </div>
      </div>
    </div>
  </div>

  <style>
    .container {
      display: flex;
      justify-content: center;
      align-items: center;
      min-height: 100vh;
      /*background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);*/
      padding: 20px;
      border-radius: 20px;
    }

    .reset-card {
      background: white;
      border-radius: 12px;
      box-shadow: 0 10px 40px rgba(0, 0, 0, 0.2);
      padding: 40px;
      max-width: 500px;
      width: 100%;
      text-align: center;
    }

    /* Wider card on larger screens to accommodate two-column layout */
    @media (min-width: 768px) {
      .reset-card {
        max-width: 750px;
      }
    }

    .loading-state,
    .success-state,
    .error-state,
    .password-form-state {
      animation: fadeIn 0.3s ease-in;
    }

    @keyframes fadeIn {
      from {
        opacity: 0;
        transform: translateY(10px);
      }
      to {
        opacity: 1;
        transform: translateY(0);
      }
    }

    .spinner {
      border: 4px solid #f3f3f3;
      border-top: 4px solid #667eea;
      border-radius: 50%;
      width: 50px;
      height: 50px;
      animation: spin 1s linear infinite;
      margin: 0 auto 20px;
    }

    @keyframes spin {
      0% { transform: rotate(0deg); }
      100% { transform: rotate(360deg); }
    }

    .success-icon,
    .error-icon {
      font-size: 64px;
      margin-bottom: 20px;
    }

    .success-icon {
      color: #10b981;
    }

    .error-icon {
      color: #ef4444;
    }

    h2 {
      color: #1f2937;
      margin-bottom: 16px;
      font-size: 24px;
      font-weight: 600;
    }

    p {
      color: #6b7280;
      line-height: 1.6;
      margin-bottom: 12px;
    }

    .next-step {
      color: #4b5563;
      font-weight: 500;
      margin-top: 20px;
      margin-bottom: 24px;
    }

    .error-message {
      color: #dc2626;
      font-weight: 500;
      margin-bottom: 24px;
    }

    .form-description {
      color: #6b7280;
      margin-bottom: 24px;
    }

    .form-group {
      margin-bottom: 20px;
      text-align: left;
    }

    label {
      display: block;
      color: #374151;
      font-weight: 500;
      margin-bottom: 8px;
      font-size: 14px;
    }

    .password-input-wrapper {
      position: relative;
      display: flex;
      align-items: center;
    }

    .password-input-wrapper input {
      width: 100%;
      padding: 12px 48px 12px 16px;
      border: 1px solid #d1d5db;
      border-radius: 8px;
      font-size: 16px;
      transition: border-color 0.2s;
      box-sizing: border-box;
    }

    .password-input-wrapper input:focus {
      outline: none;
      border-color: #667eea;
      box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
    }

    .password-toggle {
      position: absolute;
      right: 12px;
      background: none;
      border: none;
      cursor: pointer;
      padding: 4px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 20px;
      opacity: 0.6;
      transition: opacity 0.2s;
    }

    .password-toggle:hover {
      opacity: 1;
    }

    .password-toggle:focus {
      outline: 2px solid #667eea;
      outline-offset: 2px;
      border-radius: 4px;
    }

    .form-hint {
      display: block;
      color: #6b7280;
      font-size: 13px;
      margin-top: 4px;
    }

    .password-field-container {
      display: flex;
      flex-direction: column;
      gap: 12px;
      margin-bottom: 20px;
    }

    .password-input-column {
      flex: 1;
      margin-bottom: 0;
    }

    .password-requirements {
      padding: 12px;
      background: #eff6ff;
      border: 1px solid #bfdbfe;
      border-radius: 8px;
      flex-shrink: 0;
      text-align: left;
    }

    .requirements-title {
      font-size: 12px;
      color: #1e40af;
      font-weight: 600;
      margin-bottom: 4px;
    }

    .requirements-list {
      list-style: disc;
      margin-left: 16px;
      padding-left: 4px;
      font-size: 12px;
      line-height: 1.6;
    }

    .requirements-list li {
      margin-bottom: 2px;
    }

    .requirement-pending {
      color: #1d4ed8;
    }

    .requirement-met {
      color: #15803d;
      font-weight: 600;
    }

    .char-count {
      font-family: monospace;
    }

    /* Two-column layout on larger screens */
    @media (min-width: 768px) {
      .password-field-container {
        flex-direction: row;
        align-items: flex-start;
        gap: 16px;
      }

      .password-input-column {
        flex: 1;
        max-width: 400px;
      }

      .password-requirements {
        width: 280px;
        margin-top: 32px; /* Align with input field after label */
      }
    }

    .error-alert {
      background: #fee2e2;
      border: 1px solid #fecaca;
      color: #dc2626;
      padding: 12px 16px;
      border-radius: 8px;
      margin-bottom: 16px;
      font-size: 14px;
    }

    .btn {
      padding: 8px 24px;
      border-radius: 8px;
      font-weight: 500;
      cursor: pointer;
      transition: all 0.2s;
      border: none;
      font-size: 16px;
      text-decoration: none;
      display: inline-block;
    }

    .btn-block {
      width: 100%;
      display: block;
    }

    .btn-primary {
        background: var(--color-primary);
        color: white;
    }

    .btn-primary:hover:not(:disabled) {
        background: var(--color-primary);
        transform: translateY(-1px);
        box-shadow: 0 4px 12px rgba(102, 126, 234, 0.4);
    }

    .btn-primary:disabled {
        background: #9ca3af;
        cursor: not-allowed;
    }

    .error-actions {
      display: flex;
      flex-direction: column;
      gap: 12px;
      margin-top: 24px;
    }

    @media (min-width: 640px) {
      .error-actions {
        flex-direction: row;
        justify-content: center;
      }
    }
  </style>

  <script>
    import { getApi } from '../services/service-loader'

    export default {
      includeTools: false,

      state: {
        loading: true,
        tokenValid: false,
        success: false,
        error: false,
        message: '',
        userEmail: '',
        password: '',
        confirmPassword: '',
        passwordError: '',
        resetting: false,
        resetToken: '',
        showPassword: false,
        showConfirmPassword: false
      },

      async onMounted() {
        // Get token from query params
        const urlParams = new URLSearchParams(window.location.hash.split('?')[1])
        const token = urlParams.get('token')

        if (!token) {
          this.update({
            loading: false,
            error: true,
            message: this.locale?.t('resetpassword_error_notoken')
          })
          return
        }

        this.update({ resetToken: token })

        // Validate the token (just check if it exists and is valid)
        await this.validateToken(token)
      },

      async validateToken(token) {
        try {
          const api = await getApi()
          const response = await api.post('/auth/password/reset/validate', {
            resetToken: token
          })
          
          if (response.data.valid) {
            this.update({
              loading: false,
              tokenValid: true,
              error: false,
              userEmail: response.data.email || ''
            })
          } else {
            this.update({
              loading: false,
              tokenValid: false,
              error: true,
              message: response.data.message || this.locale?.t('resetpassword_error_invalidtoken')
            })
          }
        } catch (error) {
          console.error('Token validation error:', error)
          this.update({
            loading: false,
            tokenValid: false,
            error: true,
            message: error.response?.data?.message || this.locale?.t('resetpassword_error_invalidtoken')
          })
        }
      },

      handlePasswordInput(e) {
        this.update({ password: e.target.value, passwordError: '' })
      },

      handleConfirmPasswordInput(e) {
        this.update({ confirmPassword: e.target.value, passwordError: '' })
      },

      async handlePasswordSubmit(e) {
        e.preventDefault()

        const { password, confirmPassword, resetToken } = this.state

        // Validate passwords match
        if (password !== confirmPassword) {
          this.update({ passwordError: this.locale?.t('resetpassword_error_nomatch') })
          return
        }

        // Validate password strength
        if (!this.validatePasswordStrength(password)) {
          this.update({ passwordError: this.locale?.t('resetpassword_error_criteria') })
          return
        }

        this.update({ resetting: true, passwordError: '' })

        try {
          const api = await getApi()
          const response = await api.post('/auth/password/reset/complete', {
            resetToken,
            newPassword: password,
            confirmPassword
          })

          if (response.data.success) {
            this.update({
              resetting: false,
              success: true,
              tokenValid: false,
              error: false,
              message: this.locale?.t('resetpassword_success_message')
            })
          } else {
            this.update({
              resetting: false,
              passwordError: response.data.message || this.locale?.t('resetpassword_error_failed')
            })
          }
        } catch (error) {
          console.error('Password reset error:', error)

          // Handle specific error cases
          let errorMessage = this.locale?.t('resetpassword_error_tryagain')

          if (error.response?.status === 400) {
            errorMessage = error.response.data.message || this.locale?.t('resetpassword_error_invalidrequest')
          } else if (error.response?.status === 401) {
            errorMessage = this.locale?.t('resetpassword_error_invalidtoken')
          }

          this.update({
            resetting: false,
            passwordError: error.response?.data?.message || errorMessage
          })
        }
      },

      togglePasswordVisibility() {
        this.update({ showPassword: !this.state.showPassword })
      },

      toggleConfirmPasswordVisibility() {
        this.update({ showConfirmPassword: !this.state.showConfirmPassword })
      },

      validatePasswordStrength(password) {
        if (!password || password.length < 12) {
          return false
        }
        
        // Check for required character types
        const hasUppercase = /[A-Z]/.test(password)
        const hasLowercase = /[a-z]/.test(password)
        const hasNumber = /[0-9]/.test(password)
        const hasSpecialChar = /[@$!%*?&#^()_+\-=\[\]{}|;:,.<>~`]/.test(password)
        
        return hasUppercase && hasLowercase && hasNumber && hasSpecialChar
      }
    }
  </script>
</reset-password-page>